import "./progress-masterclass.css"

import { Tag, Typography } from "@suraasa/placebo-ui"
import { Masterclass } from "api/resources/masterclasses/types"
import { formatDate } from "utils/helpers"

import DEFAULT_MASTERCLASS_IMAGE from "../../../assets/Placeholder/default-masterclass-thumbnail.svg"

const ProgressMasterclass = ({ masterclass }: { masterclass: Masterclass }) => {
  if (!masterclass) return <></>

  return (
    <div>
      <div className="rounded-lg border border-onSurface-200 p-2">
        <div className="flex flex-col justify-between gap-y-1 sm:flex-row md:gap-0">
          <div className="flex flex-col sm:flex-row ">
            <img
              alt="thumbnail"
              className="w-full max-w-[167px] rounded-lg"
              src={masterclass.thumbnail || DEFAULT_MASTERCLASS_IMAGE}
              onError={e => (e.currentTarget.src = DEFAULT_MASTERCLASS_IMAGE)}
            />
            <div className="flex flex-col justify-between sm:ml-3">
              <div>
                <Typography
                  variant="preTitle"
                  className="mt-1 text-onSurface-500 sm:mt-0"
                >
                  Masterclass
                </Typography>
                <Typography
                  className="first-letter-capitalize mt-1.5 sm:mt-1"
                  variant="title3"
                >
                  {masterclass.title}
                </Typography>
              </div>
              <div className="mt-0.5 flex gap-0.5">
                <Typography variant="strong">Started at</Typography>
                <Typography variant="body">
                  {formatDate(masterclass.startTime, "d MMMM yyyy, p")}
                </Typography>
              </div>
            </div>
          </div>
          <Tag color="primary" size="sm" className="h-fit">
            In Progress
          </Tag>
        </div>
      </div>
      <div className="mt-2 flex w-full items-center gap-1.25 rounded-lg bg-highlight-50 px-2 py-1 text-highlight-600">
        <div className="pulse-circle mr-0.5 size-1.5 shrink-0 rounded-full bg-highlight-600 sm:mr-0" />
        <Typography variant="strong">
          This masterclass is in progress and will be available for viewing once
          it is finished.
        </Typography>
      </div>
    </div>
  )
}

export default ProgressMasterclass
